<button  mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<h1>{{ 'TO.Service.InsuranceInfo.InsuranceCaseTitle' | translate : 'Insurance case' }}</h1>
<mat-dialog-content style="width: 600px;">
  <div class="container">
    <div class="row">
      <div class="col-12 mt-4" style="font-size: 15px" innerHTML="{{ 'TO.Service.InsuranceInfo.InsuranceCaseGeneralInfo' | translate}}">
        {{ 'TO.Service.InsuranceInfo.ToHandleRequires' | translate : 'To be able to handle an insurance case the following is required:' }}
      </div>
      <div class="col-12 mt-4" style="font-size: 15px">
        {{ 'TO.Service.InsuranceInfo.ToHandleRequires' | translate : 'To be able to handle an insurance case the following is required:' }}
      </div>
      <div class="col-12 mt-4">
        <div style="font-size: 16px; font-weight: bold; margin-bottom: -5px">{{ 'TO.Service.InsuranceInfo.IfDamage' | translate : 'If damage' }}</div>
        <mat-list style="overflow-y: visible; overflow-x: auto">
          <mat-list-item style="font-size: 15px !important">
            <mat-icon style="margin-right: 5px">check_circle</mat-icon>
            {{ 'TO.Service.InsuranceInfo.PicturesOfDamage' | translate : 'Pictures of eventual damages' }}
          </mat-list-item>
          <mat-list-item style="font-size: 15px !important">
            <mat-icon style="margin-right: 5px">check_circle</mat-icon>
            {{ 'TO.Service.InsuranceInfo.DamageReportForm' | translate : 'Damage report form' }}
          </mat-list-item>
        </mat-list>
      </div>
      <div class="col-12 mt-4">
        <div style="font-size: 16px; font-weight: bold; margin-bottom: -5px">{{ 'TO.Service.InsuranceInfo.IfTheft' | translate : 'If theft' }}</div>
        <mat-list style="overflow-y: visible; overflow-x: auto">
          <mat-list-item style="font-size: 15px !important">
            <mat-icon style="margin-right: 5px">check_circle</mat-icon>
            {{ 'TO.Service.InsuranceInfo.RecordNumberFromPolice' | translate : 'Record number from police report' }}
          </mat-list-item>
        </mat-list>
      </div>
    </div>
  </div>
  <div class="loader" *ngIf="loading">
    <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
    <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;" *ngIf="loading"></mat-progress-bar>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="col-12" style="text-align: right; padding-left: 5px; padding-right: 5px;">
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="agree()" [disabled]="loading">{{ 'Turbo.Service.CreateServiceRequestDialog.IUnderStand' | translate : 'I understand' }}</button>
    <button mat-flat-button style="margin: 3px;" (click)="cancel()" [disabled]="loading">{{ 'Turbo.Service.CreateServiceRequestDialog.Cancel' | translate : 'Cancel' }}</button>
  </div>
</mat-dialog-actions>
